import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, Button, CircularProgress, Grid } from '@mui/material';
import AssignPopup from '../../../../../components/popup/AssignPopup';
import { AssignUser } from '../../../../../api/Endpoints/Assign';
import moment from 'moment';
import AssignNotesPopup from '../../../../../components/popup/AssignNotes';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import { Note } from '@mui/icons-material';
import SendForMaintanencePopup from '../../../../../components/popup/SendForMaintanencePopup';

function MaintananceHistory({ id }) {
    const [editID, setEditId] = useState(0);
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const [unAssignId, setUnAssignId] = useState(0);
    const [refresh, setRefresh] = useState(0);
    const [showNotesPopup, setShowNotesPopup] = useState(false);
    const [notes, setNotes] = useState({
        assign_note: '',
        return_note: '',
        cost: ''
    });

    const handleAssignBtnClick = () => {
        setEditId(undefined);
    };

    const columns = [
        {
            field: 'vendor',
            headerName: 'Vendor',
            width: 150,
            renderCell: (params) => <>{params.row?.vendor?.name}</>,
        },
        {
            field: 'assigned_date',
            headerName: 'Assigned Date',
            width: 150,
            renderCell: (params) => <>{moment(params.row?.assigned_on).format('DD-MM-YYYY')}</>,
        },
        {
            field: 'returned-date',
            headerName: 'Returend  Date',
            width: 130,
            renderCell: (params) => <>
                {params.row?.returned_on && moment(params.row?.returned_on).format('DD-MM-YYYY')}
            </>,
        },
        {
            field: 'note',
            headerName: 'Notes',
            width: 100,
            renderCell: (params) => {
                if (params?.row?.assigned_note) {
                    return (
                        <Button onClick={() => showNotes({ assign_note: params.row.assigned_note, release_note: params.row.return_note, cost: params.row?.cost })}>
                            <TextSnippetOutlinedIcon />
                        </Button>
                    );
                } else {
                    return null;
                }
            },
        }

    ];

    const SendForMaitanace = () => {
        setUnAssignId(data?.current_maintenance?.id);
    };

    useEffect(() => {
        fetchAssignHistoryTable();
    }, [id, refresh]);

    const fetchAssignHistoryTable = async () => {
        setLoading(true);
        const res = await AssignUser.getAssignHistoryTable({ id: id });
        setData(res?.data.data);
        setLoading(false);
    };

    const handleUpdate = () => {
        setRefresh(Math.random);
    };

    const showNotes = (Notes) => {

        setNotes({
            assign_note: Notes?.assign_note,
            release_note: Notes?.release_note,
            cost: Notes?.cost
        });
        setShowNotesPopup(true);
    };

    return (
        <>
            {!loading ? (
                <Box sx={{ height: 500, width: '100%' }}>
                    {data?.current_maintenance?.vendor?.name ? (
                        <Grid display={'flex'} justifyContent={'end'} marginLeft={3}>
                            <Button variant='contained' onClick={SendForMaitanace} sx={{
                                background: 'rgb(20,184,166)',
                                '&:hover': {
                                    background: 'rgb(20,184,166)',
                                }
                            }}> Return from Maintenance</Button>
                        </Grid>
                    ) : (
                        <Grid display={'flex'} justifyContent={'end'} marginLeft={3}>
                            <Button variant='contained' onClick={handleAssignBtnClick} >Send For Maintenance</Button>
                        </Grid>
                    )}

                    <SendForMaintanencePopup editID={editID} setEditId={setEditId} itemId={id} UnassignId={unAssignId} setUnAssignId={setUnAssignId} onUpdate={handleUpdate} />

                    {data && (
                        <DataGrid
                            rows={data?.maintenance}
                            columns={columns}
                            pageSize={5}
                            rowsPerPageOptions={[5]}
                            disableSelectionOnClick
                        />
                    )}

                    {showNotesPopup && (
                        <AssignNotesPopup
                            Open={showNotesPopup}
                            setOpen={setShowNotesPopup}
                            assign_note={notes.assign_note}
                            release_note={notes.release_note}
                            cost={notes?.cost}

                            fromMaintanceTab={true}
                        />
                    )}
                </Box>
            ) : (
                <Box
                    sx={{
                        width: "100%",
                        height: "50%",
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "10px",
                    }}
                >
                    <CircularProgress sx={{ color: "blue" }} />
                </Box>
            )}
        </>
    );
}

export default MaintananceHistory;
